export const SUITE_NAME = "Roughly";
export const SUITE_TAGLINE = {
    de: "Dein Bauchgefühl auf dem Prüfstand.",
    en: "Put your gut feeling to the test.",
};
export const GAME_BRANDING = {
    timeslip: {
        id: "timeslip",
        name: "LineUp",
        tagline: {
            de: "Bring fünf Ereignisse in die richtige Reihenfolge.",
            en: "Put five events in the right order.",
        },
        roundsInfo: {
            de: "5 Runden",
            en: "5 rounds",
        },
    },
    crowflight: {
        id: "crowflight",
        name: "Beeline",
        tagline: {
            de: "Wie weit ist es wirklich? Sortieren, vergleichen, schätzen.",
            en: "How far is it, really? Sort, compare, estimate.",
        },
        roundsInfo: {
            de: "4 Runden",
            en: "4 rounds",
        },
    },
    huesswork: {
        id: "huesswork",
        name: "Halfway",
        tagline: {
            de: "Welche Farbe fehlt in der Mitte?",
            en: "Which color is missing in the middle?",
        },
        roundsInfo: {
            de: "5 Runden",
            en: "5 rounds",
        },
    },
};
export const DEFAULT_GAME_ORDER = ["timeslip", "crowflight", "huesswork"];
//# sourceMappingURL=branding.js.map